export const FESTIVE_DAYS_LOADING = "FESTIVE_DAYS_LOADING";
export const FESTIVE_DAYS_ERROR = "FESTIVE_DAYS_ERROR";

export const FESTIVE_DAYS_ADD = "FESTIVE_DAYS_ADD";
export const FESTIVE_DAYS_UPDATE = "FESTIVE_DAYS_UPDATE";
export const FESTIVE_DAYS_DELETE = "FESTIVE_DAYS_DELETE";
export const FESTIVE_DAYS_FILTERS = "FESTIVE_DAYS_FILTERS";
export const FESTIVE_DAYS_SEARCH = "FESTIVE_DAYS_SEARCH";
export const FESTIVE_DAYS_SINGLE = "FESTIVE_DAYS_SINGLE";
export const FESTIVE_DAYS_TYPES = "FESTIVE_DAYS_TYPES";



// WEBPACK FOOTER //
// ./src/actions/festive-days/constants.js